export default "__VITE_ASSET__BaJyP3So__"